<template>
    <div class="customer-dashboard">
        <div class="IFrameLoader" id="my-superset-container">
            <h1>Dashboard is being loaded ...</h1>
        </div>
    </div>
</template>

<script>
import {
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import { embedDashboard } from "@superset-ui/embedded-sdk";
import { APACHE_SUPERSET } from '@/assets/js/config';

export default {
    mixins: [helperFunctionMixin],
    methods: {
        getDashboardId() {
            return "f67a5e1a-3233-445f-b7c4-753f865bcbce";
        },
        async guestToken(){
            const dashboard_id = this.getDashboardId();
            const apache_superset_token = localStorage.getItem(`superset_token_${dashboard_id}`) || '';
            const result = await axios.get(services.access_control+'get_dashboard_token', {
                headers: getHeader(),
                params: {
                    dashboard_id,
                    apache_superset_token
                }
            });
            const token = result.data.token;
            if (token) {
                localStorage.setItem(`superset_token_${dashboard_id}`, token);
                return token;
            }
            return token;
        }
    },
    created() {
        setTimeout(() => {

            embedDashboard({
                id: this.getDashboardId(), // given by the Superset embedding UI
                supersetDomain: APACHE_SUPERSET,
                mountPoint: document.getElementById("my-superset-container"), // any html element that can contain an iframe
                fetchGuestToken: () => this.guestToken(),
                dashboardUiConfig: {
                    hideTitle: true,
                    filters: {
                        expanded: false,
                        visible: false
                    },
                },
            });
        }, 2000);

        console.log('LeadReport')
    }
}
</script>
